var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      class: { show: _vm.mobileMode && _vm.menuOpened },
      attrs: { id: "ci-portfolios-comparison-filters" },
    },
    [
      _vm.mobileMode
        ? [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.menuOpened,
                    expression: "menuOpened",
                  },
                ],
                ref: "mobileMenu",
                staticClass: "mobile-menu p-3 bg-white mt-auto",
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.displayFiltersMenu,
                        expression: "displayFiltersMenu",
                      },
                    ],
                    staticClass: "w-100 h-100",
                    attrs: { id: "filter-tab" },
                  },
                  [
                    _c("div", { staticClass: "row m-0" }, [
                      _c("h4", {
                        staticClass:
                          "h4 text-xxl col-10 m-0 p-0 d-flex align-items-center",
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t(
                              "ui.components.portfolios.comparisons.filter_and_sorting_label"
                            )
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass:
                          "col-2 mdi mdi-24px mdi-close d-flex justify-content-end",
                        on: { click: _vm.closeMenu },
                      }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "sorting-section row mx-0 my-2",
                        on: { click: _vm.toggleSortingMenu },
                      },
                      [
                        _c("h5", {
                          staticClass:
                            "h5 col-6 d-flex align-items-center m-0 p-0",
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t(
                                "ui.components.portfolios.comparisons.sorting.label"
                              )
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("p", {
                          staticClass: "current-sorting col-5 text-center",
                          domProps: {
                            textContent: _vm._s(
                              _vm.currentSortingSelected.label
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass:
                            "mdi mdi-24px mdi-chevron-right d-flex align-items-center",
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "row m-0" }, [
                      _c("h5", {
                        staticClass:
                          "h5 col-2 m-0 p-0 d-flex align-items-center",
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t(
                              "ui.components.portfolios.comparisons.filters.label"
                            )
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-9" },
                        [
                          _c("ais-current-refinements", {
                            staticClass: "h-100 d-flex align-items-center",
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ items }) {
                                    return [
                                      _c(
                                        "p",
                                        { staticClass: "current-filters" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.currentFilters(items))
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3210508252
                            ),
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-1" },
                        [
                          _c("ci-clear-refinements", {
                            staticClass: "p-0",
                            attrs: { "with-icon": true, variant: "visibility" },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row mx-0 mt-3" },
                      [
                        _c("ci-ais-range-with-period", {
                          staticClass: "w-100",
                          attrs: {
                            attribute: "performance.performance",
                            options: _vm.filterOptions,
                            label: _vm.$t(
                              "ui.components.portfolios.comparisons.filters.performance"
                            ),
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row mx-0 mt-3" },
                      [
                        _c("ci-ais-range-with-period", {
                          staticClass: "w-100",
                          attrs: {
                            attribute: "performance.volatility",
                            options: _vm.filterOptions,
                            label: _vm.$t(
                              "ui.components.portfolios.comparisons.filters.volatility"
                            ),
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "ais-sort-by",
                  { attrs: { items: _vm.sortingOptions } },
                  [
                    _vm.displaySortingMenu
                      ? _c(
                          "div",
                          {
                            staticClass: "w-100 h-100",
                            attrs: { id: "sorting-tab" },
                          },
                          [
                            _c("div", { staticClass: "row m-0" }, [
                              _c("div", {
                                staticClass:
                                  "col-2 mdi mdi-24px mdi-chevron-left p-0",
                                on: { click: _vm.toggleFiltersMenu },
                              }),
                              _vm._v(" "),
                              _c("h4", {
                                staticClass:
                                  "h4 text-xxl col-8 m-0 p-0 d-flex align-items-center",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "ui.components.portfolios.comparisons.sorting.label"
                                    )
                                  ),
                                },
                              }),
                              _vm._v(" "),
                              _c("div", {
                                staticClass:
                                  "col-2 mdi mdi-24px mdi-close d-flex justify-content-end",
                                on: { click: _vm.closeMenu },
                              }),
                            ]),
                            _vm._v(" "),
                            _vm._l(
                              _vm.sortingOptions,
                              function (option, index) {
                                return [
                                  _c(
                                    "div",
                                    { key: index, staticClass: "row m-0" },
                                    [
                                      _c("ci-radio", {
                                        attrs: {
                                          "field-value": option.label,
                                          label: option.label,
                                        },
                                        on: {
                                          input: function ($event) {
                                            return _vm.handleSortingSelected(
                                              option
                                            )
                                          },
                                        },
                                        model: {
                                          value: _vm.optionSelected,
                                          callback: function ($$v) {
                                            _vm.optionSelected = $$v
                                          },
                                          expression: "optionSelected",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              }
                            ),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("ais-stats", {
                      staticClass: "bg-white p-3 w-100",
                      attrs: { id: "show-results" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ nbHits }) {
                              return [
                                _c("ci-button", {
                                  staticClass: "w-100",
                                  attrs: {
                                    label: _vm.$t(
                                      "ui.components.portfolios.comparisons.results",
                                      { hits: nbHits }
                                    ),
                                    variant: "filled-primary",
                                  },
                                  on: { click: _vm.toggleMenu },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        4067195981
                      ),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      !_vm.mobileMode
        ? [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "click-outside",
                      rawName: "v-click-outside",
                      value: _vm.closeFiltersMenu,
                      expression: "closeFiltersMenu",
                    },
                  ],
                  staticClass: "col-6",
                  attrs: { id: "filters" },
                },
                [
                  _c("ais-current-refinements", {
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ items }) {
                            return [
                              _c("ci-input", {
                                attrs: {
                                  value: _vm.currentFilters(items),
                                  label: _vm.$t(
                                    "ui.components.portfolios.comparisons.filters.label"
                                  ),
                                  "trailing-icon": "mdi-chevron-down",
                                  readonly: "",
                                },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.toggleFiltersMenu.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3340872891
                    ),
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.displayFiltersMenu,
                          expression: "displayFiltersMenu",
                        },
                      ],
                      staticClass: "p-4 bg-white",
                      attrs: { id: "filters-menu" },
                    },
                    [
                      _c("div", { staticClass: "row m-0" }, [
                        _c("h4", {
                          staticClass:
                            "h4 col-6 m-0 p-0 d-flex align-items-center",
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t(
                                "ui.components.portfolios.comparisons.filters.label"
                              )
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-6 p-0 d-flex justify-content-end",
                          },
                          [_c("ci-clear-refinements")],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "row mx-0 mt-3" },
                        [
                          _c("ci-ais-range-with-period", {
                            staticClass: "w-100",
                            attrs: {
                              attribute: "performance.performance",
                              options: _vm.filterOptions,
                              label: _vm.$t(
                                "ui.components.portfolios.comparisons.filters.performance"
                              ),
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "row mx-0 mt-3" },
                        [
                          _c("ci-ais-range-with-period", {
                            staticClass: "w-100",
                            attrs: {
                              attribute: "performance.volatility",
                              options: _vm.filterOptions,
                              label: _vm.$t(
                                "ui.components.portfolios.comparisons.filters.volatility"
                              ),
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "click-outside",
                      rawName: "v-click-outside",
                      value: _vm.closeSortingMenu,
                      expression: "closeSortingMenu",
                    },
                  ],
                  staticClass: "col-6",
                  attrs: { id: "sorting" },
                },
                [
                  _c(
                    "ais-sort-by",
                    { attrs: { items: _vm.sortingOptions } },
                    [
                      _c("ci-input", {
                        attrs: {
                          "input-id": "current-selected-sorting",
                          value: _vm.currentSortingSelected.label,
                          label: _vm.$t(
                            "ui.components.portfolios.comparisons.sorting.label"
                          ),
                          "trailing-icon": "mdi-chevron-down",
                          readonly: "",
                        },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.toggleSortingMenu.apply(null, arguments)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm.displaySortingMenu
                        ? _c(
                            "div",
                            {
                              staticClass: "bg-white",
                              attrs: { id: "sorting-menu" },
                            },
                            [
                              _vm._l(
                                _vm.sortingOptions,
                                function (option, index) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass: "sorting-option row m-0",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleSortingSelected(
                                              option
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(option.label) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ]
                                }
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }